import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { auth as authApi } from "@/lib/api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    try {
      const u = await authApi.me();
      setUser(u);
      return u;
    } catch {
      localStorage.removeItem("xseed_token");
      setUser(null);
    }
  }, []);

  useEffect(() => {
    const t = localStorage.getItem("xseed_token");
    if (!t) { setLoading(false); return; }
    refresh().finally(() => setLoading(false));
  }, [refresh]);

  const login = async (email, password) => {
    const res = await authApi.login(email, password);
    localStorage.setItem("xseed_token", res.access_token);
    await refresh();
    return res.user;
  };
  const register = async (data) => {
    const res = await authApi.register(data);
    localStorage.setItem("xseed_token", res.access_token);
    await refresh();
    return res.user;
  };
  const logout = () => {
    localStorage.removeItem("xseed_token");
    setUser(null);
  };

  return (
    <AuthCtx.Provider value={{ user, loading, login, register, logout, refresh }}>
      {children}
    </AuthCtx.Provider>
  );
}

export const useAuth = () => useContext(AuthCtx);
